module.exports = __webpack_public_path__ + "static/media/cpg_theoutcome_boardroom.8f27c8ed.png";